<template>
  <nav class="navbar navbar-dark navbar-expand-lg" aria-label="Resource Navigation">
    <div v-if="$route.name === 'Home' || $route.name === 'DownloadData'">
      <label for="Select School Year" class="bar-label first-item">School Year </label>
      <select id="Select School Year" v-model="selectedSchoolYear" class="form-select">
        <option v-for="year in schoolYears" :key="year.value" :value="year.value">
          {{ year.text }}
        </option>
      </select>
    </div>
    <div class="section-head d-block d-xl-none">
      <span v-if="$route.name !== 'Home'" class="pl-4 home d-lg-none">
        <router-link :to="{ name: 'Home' }" class="text-white">
          <font-awesome-icon :icon="['fa', 'home']" />
        </router-link>
      </span>
    </div>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon" />
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav">
        <li v-if="$route.name !== 'Home'" class="nav-item pl-4">
          <router-link class="nav-link active" aria-current="page" :to="{ name: 'Home' }">
            Home
          </router-link>
        </li>
        <li class="nav-item headersub">
          <div class="dropdown">
            <button
              aria-haspopup="true"
              aria-expanded="false"
              class="btn dropdown dropdown-toggle px-2 pb-2 pb-xl-0"
              type="button"
              data-toggle="dropdown"
            >
              <span class="nav-item pl-3">Resource Documents</span>
              <span class="caret" />
            </button>
            <ul class="dropdown-menu">
              <li>
                <a
                  href="/Documents/ReferenceGuide.pdf"
                  class="bar-label"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Reference Guide
                </a>
              </li>
              <li>
                <a
                  href="/Documents/FAQs.pdf"
                  class="bar-label"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Frequently Asked Questions
                </a>
              </li>
              <li>
                <router-link :to="{ name: 'Additional' }" class="bar-label">
                  All Resources
                </router-link>
              </li>
              <li>
                <a
                  href="/Documents/DataPrivacyRules.pdf"
                  class="bar-label"
                  target="_blank"
                  rel="noopener noreferrer"
                >Data Privacy Rules (FERPA)</a>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-item pl-4">
          <a
            href="https://forms.office.com/r/a8yvcRk7DB"
            class="nav-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Take Feedback Survey
          </a>
        </li>
        <li class="nav-item">
          <a
            v-if="showDownload"
            class="nav-background bar-label nav-link mx-auto pl-4"
            href="/download"
          >
            Download Data
          </a>
        </li>
        <li class="nav-item pl-4">
          <a class="nav-link" href="mailto:reportcard@doe.nj.gov">
            Contact Us</a>
        </li>
        <!-- <li
          v-if="isValid"
          class="nav-item pl-4 pt-2 pr-3"
          tabindex="0"
          @click="toggleLanguage"
          @keydown.enter="toggleLanguage"
        >
          <font-awesome-icon :icon="['fa', 'globe-americas']" />
          Language: {{ languageDisplay }}
        </li> -->
      </ul>
      <button
        v-if="isValid"
        type="button"
        class="btn btn-language"
        tabindex="0"
        @click="toggleLanguage"
        @keydown.enter="toggleLanguage"
      >
        <font-awesome-icon :icon="['fa', 'globe-americas']" />
        Language: {{ languageDisplay }}
      </button>
    </div>
  </nav>
</template>

<script>
import TranslationService from '../services/translation.service';

export default {
  name: 'ResourceBar',
  data() {
    return {
      showResourceDocs: false,
      languageCodes: TranslationService.Constants.LanguageOptions,
    };
  },
  computed: {
    languageCode() {
      return this.$store.getters.CurrentLanguage;
    },
    languageDisplay() {
      return this.languageCode === this.languageCodes.English ? 'Eng' : 'Esp';
    },
    schoolYears() {
      return this.$store.getters.CurrentSchoolYears;
    },
    selectedSchoolYear: {
      get() {
        return this.$store.getters.SelectedSchoolYear ? this.$store.getters.SelectedSchoolYear.value : '';
      },
      set(value) {
        this.$store.dispatch('setSelectedSchoolYear', value);
        this.$emit('schoolYearChanged', value);
      },
    },
    showDownload() {
      return this.$store.getters.SelectedSchoolYear
        && !this.$store.getters.SelectedSchoolYear.embargo;
    },
    schoolYear() {
      return this.$store.getters.SelectedSchoolYear ? this.$route.params.schoolYear : '';
    },
    shortschoolYear() {
      return this.$store.getters.SelectedSchoolYear ? this.$store.getters.SelectedSchoolYear.value : '';
    },
    isValid() {
      if (process.env.VUE_APP_SHOW_SPANISH_REPORTS !== 'Yes'
        && this.$store.getters.SelectedSchoolYear.embargo) {
        return false;
      }
      switch (this.$route.name) {
        case 'SummaryReport':
        case 'DetailReport':
        case 'Overview':
        case 'Demographics':
        case 'StudentGrowth':
        case 'AcademicAchievement':
        case 'CollegeCareer':
        case 'PostSecondary':
        case 'Climate':
        case 'Staff':
        case 'PerPupil':
        case 'Accountability':
        case 'Narrative':
        case 'Default':
          return true;
        default:
          return false;
      }
    },
    documents() {
      return process.env.VUE_APP_DOCUMENTS;
    },
    referenceGuide() {
      return process.env.VUE_APP_REFERENCE_GUIDE;
    },
  },
  methods: {
    toggleLanguage() {
      this.$store.dispatch(
        'setCurrentLanguage',
        this.languageCode === TranslationService.Constants.LanguageOptions.English
          ? TranslationService.Constants.LanguageOptions.Spanish
          : TranslationService.Constants.LanguageOptions.English,
      );
    },
    toggleResourceDocs() {
      this.showResourceDocs = !this.showResourceDocs;
    },
  },
};
</script>

<style scoped>
.dropdown-menu {
  background-color: #426580 !important;
  color: white;
}
.dropdown-menu li a{
  display: block;
  color: white;
  margin: 10px;
  font-size: 14px;
  text-decoration: none;
  min-width: 200px;
}
.btn:focus {
  border: 1px solid #fff;
}
.headersub li:hover, .headersub li a:hover{
  background-color: #a9d08e;
  color: #000;
}
.headersub .dropdown {
  color: white;
}
.headersub .dropdown:hover {
  color: white;
}
.navbar {
  background-color: #426580;
  height: 55px;
  max-height: 55px;
  min-height: 55px;
  padding: 0;
}

.nav-background, .nav-item {
  background-color: #426580;
  z-index: 1;
}

.nav-item, .nav-link {
  text-decoration: none !important;
  color: #FFF !important;
  font-size: 14px;
}

.bar-label.first-item {
  display: inline-block;
  padding-right: 5px;
  color: #fff;
  padding-left: 20px;
}
select {
  width: 130px;
  margin-top: 3px;
  border-radius: 4px;
}

.home {
  font-size: 20px;
  color: #fff;
  vertical-align: bottom;
}
.btn-language {
  text-decoration: none !important;
  color: #FFF !important;
  font-size: 14px;
  width: 200px;
}
</style>
